import { Navigate } from "react-router-dom";

import { useAuthStore } from "@/stores/auth-store";

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * Redirects during render via <Navigate> rather than in an effect, so there's
 * no null-render flash.
 *
 * To work as a fixed user in dev, set `VITE_DEV_AUTH_JWT`: it is seeded as the
 * token at startup (see `seedDevAuthToken`), so the normal session path applies
 * and no bypass is needed here.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
